export const formMixin = {
  data: {
    formInProgress: false,
  },

  methods: {
    blockUi: (el, unblock = false) => {
      if (unblock) {
        $(el).unblock();
        return;
      }

      $(el).block({
        message: '<i class="icon-spinner4 spinner"></i>',
        timeout: 30000, // unblock after 30 seconds
        overlayCSS: {
          backgroundColor: '#fff',
          opacity: 0.8,
          cursor: 'wait',
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: 'transparent',
        },
      });
    },

    /**
     * Highlight Form Errors
     * @param data
     */
    formHandleErrors(data) {
      const _this = this;
      console.error('formHandleErrors', data);

      if (data.status === 401) { // Unauthorized
        _this.notifyError(data.responseText);
        return;
      }

      if (data.status === 500) { // Exception
        _this.notifyError("Error code: " + moment().format('YYMMDD-HHmmss'));
        return;
      }

      let {responseJSON: response} = data;
      let errors = [];

      if (response) {
        if (typeof response.message != 'undefined') {
          _this.notifyError(response.message);
        } else {
          _this.notifyError(this.trans('Hata oluştu, lütfen formdaki hataları kontrol edip tekrar deneyin.'));
        }

        if (typeof response.errors != 'undefined') {
          errors = response.errors;
        } else {
          errors = response;
        }
      }

      $.each(errors, function (key, item) {
        _this.formAddErrors(key, item);
      });
    },

    formAddErrors(inputName, message) {
      const _this = this;
      if (inputName === 'alert') {
        _this.notifyError(message);
      }

      const $input = _this.formFindInputByName(inputName);
      if (! $input) {
        return;
      }

      // add form errors.
      const $fgroup = $input.closest('.form-group');
      if ($fgroup.length) {
        $fgroup.addClass('has-error');
        $fgroup.append('<span class="text-danger">' + message[0] + '</span>');
      } else {
        $input.addClass('is-invalid');
        $input.after('<div class="invalid-feedback">' + message[0] + '</div>');
      }

      // switch to related tab in .tab-pane
      const tabid = $fgroup.closest('.tab-pane').attr('id');
      $('.nav-tabs a[href="#' + tabid + '"]').tab('show');
    },

    formFindInputByName(field) {
      let $field = $("[name='" + field + "']");

      if ($field.length === 0) {
        $field = $("[name*='" + field + "']");
      }

      if ($field.length === 0) {
        const fieldDotParts = field.split('.');
        let fieldTemp = fieldDotParts[0];
        for (let i = 1; i < fieldDotParts.length; i++) {
          fieldTemp += '\\[' + fieldDotParts[i] + '\\]';
        }
        field = fieldTemp;
        $field = $("[name='" + field + "']");
      }

      if ($field.length === 0) {
        $field = $("[name*='" + field + "']");
      }

      if ($field.length === 0) {
        return false;
      }

      return $field;
    },

    formClearErrors() {
      $(".has-error").removeClass('has-error').find('.text-danger').remove();
      $(".is-invalid + .invalid-feedback").remove();
      $(".is-invalid").removeClass('is-invalid');
    },

    _handleForm(form = '#form') {
      const _this = this;

      if (_this.formInProgress) {
        console.error('Request already in progress.');
        return false;
      }

      if (_.isString(form)) {
        form = $(form);
      }

      if (!form || !form.length) {
        console.error('Form not found.');
        return false;
      }

      _this.formInProgress = true;
      _this.blockUi(form);
      _this.formClearErrors();

      return form;
    },

    /**
     * Form Submit helper. Doesn't use ajax request.
     * @param form
     */
    formSubmitNonJs(form = '#form') {
      form = this._handleForm(form);

      form.submit();
    },

    /**
     * Form Submit helper. Submits via ajax request.
     * @param form
     * @param props
     * @param success
     * @param fail
     * @param always
     * @returns {boolean}
     */
    formSubmit({form = '#form', ajaxProps, success, fail, always}) {
      const _this = this;
      form = this._handleForm(form);

      // noinspection JSUnresolvedFunction
      $.ajax({
        url: form.prop('action'),
        method: form.prop('method'),
        data: form.serialize(),
        dataType: 'json',
        ...ajaxProps,
      })
        .done(success)
        .fail((data) => {
          _this.formHandleErrors(data);
          if (typeof fail === "function") {
            fail(data);
          }
        })
        .always((data) => {
          _this.formInProgress = false;
          _this.blockUi(form, true);

          if (typeof always === "function") {
            always(data);
          }
        });

      return true;
    },
  }
};
